import { Provider } from 'react-redux';
import { MainRouter } from './scenes/MainRouter';
import store from './store/index';
import { BrowserRouter as Router } from 'react-router-dom';
import { LicenseInfo } from '@mui/x-license-pro';

/**
 * Expired license keys:
 * @returns 
 * - 14 October, 2024
 * - c0981cce56b374bf661c85d6fc240e04Tz03NDYzMSxFPTE3MjYyNjY0MTQwMDAsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y 
 */
LicenseInfo.setLicenseKey('5d936811fbd2c1c45d6cea5c0bb14426Tz0xMjA3NjYsRT0xNzkyNzEzNTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y');

function App() {
  return (
    <Provider store={store}>
      <Router>
        <MainRouter />
      </Router>
    </Provider>
  );
}

export default App;
